import { CommonModule } from "@angular/common";
import { Component, input, InputSignal } from "@angular/core";
import { FadeColorPipe } from "@sportyano/shared/pipes/colors/fade-color.pipe";

@Component({
	selector: "chip",
	standalone: true,
	imports: [CommonModule, FadeColorPipe],
	templateUrl: "./chip.component.html",
	styleUrl: "./chip.component.scss",
})
export class ChipComponent {
	public colorHex: InputSignal<string> = input.required();
	public label: InputSignal<string> = input('');
	public icon: InputSignal<string> = input("");
}
